import { MagicLetterBoxLink } from "@/components/funnel/MagicLetterBoxLink";
import { Link } from "react-router-dom";
import { elfLetterOccasionUrl } from "@/data/elfLetterOccasions";

const occasions: Record<string, { title: string; answer: string; note: string }> = {
  "accidentally-touched-holiday-elf-restore-magic-guide": {
    title: "First, let them know nothing is ruined",
    answer: "A curious touch or an accidental fall does not need to become a worry. Tell your child they did nothing wrong. You can continue your family's elf story without asking them to earn the magic back.",
    note: "Hello, friend! A little hello hasn't spoiled our Christmas fun. I'm happy to be here, and there's another adventure waiting for us. Love, Your Elf",
  },
  "holiday-elf-departure-letters-guide": {
    title: "Need a goodbye letter tonight?",
    answer: "Keep it short: recall a happy moment, thank your child for the visit, and give the story a warm ending. You don't need a big final scene.",
    note: "My little suitcase is packed, and it's time to head home. Thank you for sharing your Christmas adventures with me. Keep being curious and kind! Love, Your Elf",
  },
};

export default function OccasionLetterCallout({ slug }: { slug: string }) {
  const occasion = occasions[slug];
  if (!occasion) return null;
  return (
    <aside aria-label="Quick letter help" className="mx-auto mb-10 max-w-3xl rounded-2xl border border-elfGreen/30 bg-elfGreen-light/40 p-6 md:p-8">
      <h2 className="text-2xl font-bold">{occasion.title}</h2>
      <p className="mt-3 leading-relaxed">{occasion.answer}</p>
      <p className="mt-5 text-xs font-semibold uppercase tracking-wide text-elfGreen-ink">A short example you can use</p>
      <blockquote className="my-3 border-l-2 border-elfGreen pl-4 italic leading-relaxed">{occasion.note}</blockquote>
      <p className="mb-4 text-sm text-slate-700">Want a letter with your child's name, your elf's voice, and a memory from your own family? Continue at The Magic Letter Box.</p>
      <MagicLetterBoxLink source={`occasion-${slug}`}>Create this letter for your child</MagicLetterBoxLink>
      <p className="mt-3 text-xs text-slate-600">Five letters in the parent trial. Unlimited letters require Family membership.</p>
      {slug === "holiday-elf-departure-letters-guide" && (
        <p className="mt-4 text-sm text-slate-700">
          <Link
            to={elfLetterOccasionUrl("goodbye")}
            className="rounded-sm font-semibold text-elfGreen-ink underline underline-offset-4 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-700 focus-visible:ring-offset-2"
          >
            Try the free goodbye letter starter
          </Link>
          . Includes three PDF deliveries per email address.
        </p>
      )}
    </aside>
  );
}
